$(document).ready(function() {
    // Initially hide the SEPA mandate
    $('.sepa-mandate-wrapper').hide();

    // Watch for changes in the account number input
    $("#investors_bank_account_form_account_number").on('input', function() {
        const iban = $(this).val().toUpperCase();
        const surepayCountries = $(this).data("surepayCountries");
        const oneTimeSurepayCountries = $(this).data("oneTimeSurepayCountries");
        const bankAccountStatus = $(this).data("status");

        if (iban && iban.length >= 2 && !surepayCountries.includes(iban.substring(0, 2))
            || (oneTimeSurepayCountries.includes(iban.substring(0, 2)) &&
                bankAccountStatus == "surepay_verification_failed")) {
            $('.sepa-mandate-wrapper').show();
        } else {
            $('.sepa-mandate-wrapper').hide();
        }
    });
});